import React from "react";
import { ShieldAlert } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "./alert";
import { Button } from "./button";
import { Card, CardContent, CardFooter } from "./card";

/** Full-screen card for a signed-in user whose token lacks the required role. */
export function ForbiddenScreen({ title, message, onRetry, onSignOut }: {
  /** e.g. "Admin claim required" / "Client account required" */
  title: React.ReactNode;
  message: React.ReactNode;
  onRetry: () => void;
  onSignOut: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="pt-6">
          <Alert variant="warning">
            <ShieldAlert className="h-4 w-4" />
            <AlertTitle>{title}</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
          </Alert>
        </CardContent>
        <CardFooter className="gap-2">
          <Button variant="outline" onClick={onRetry}>Try another account</Button>
          <Button variant="ghost" onClick={onSignOut}>Sign out</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
